/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Html from '../partials/Html';
import Image from '../partials/Image';

import styles from '../../../styles/cards/image.module.scss';

const propTypes = {
    item: AppPropTypes.card.isRequired,
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    theme: null,
    className: null,
};

const ImageCard = ({ item, theme, className }) => {
    const { image = null, alt = null, description = null, spacing = null } = item || {};

    const style = useMemo(() => {
        if (spacing === null) {
            return null;
        }

        const numericSpacing = parseInt(spacing, 10);
        if (spacing < 1) {
            return null;
        }

        return {
            width: `calc(100% + ${numericSpacing}%)`,
            height: 'auto',
            right: 'auto',
            left: `-${numericSpacing / 2}%`,
            bottom: `-${numericSpacing / 2}%`,
            top: 'auto',
        };
    }, [spacing]);
    return (
        <div
            className={classNames([
                styles.container,
                styles[theme],
                {
                    [styles.hasDescription]: description !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.top}>
                    {image !== null ? (
                        <Image
                            className={styles.image}
                            size="medium"
                            media={image}
                            alt={alt || 'Carte'}
                            style={style}
                        />
                    ) : null}
                </div>
                <div className={styles.bottom}>
                    <Html body={description} />
                </div>
            </div>
        </div>
    );
};

ImageCard.propTypes = propTypes;
ImageCard.defaultProps = defaultProps;

export default ImageCard;
